module.exports = __webpack_public_path__ + "images/74d72ed65fe8d0be3bb857254c5a014e.svg";